import { configureStore } from "@reduxjs/toolkit";

// slices
import auth from "./slices/auth";
import country from "./slices/country";
import opportunity from "./slices/opportunity";
import training from "./slices/training";
import loading from "./slices/loading";
import companies from "./slices/companies";
import blog from "./slices/blog";
import user from "./slices/users";
import companiesFile from "./slices/companiesFile";
import service from "./slices/services";
import request from "./slices/request";
import setting from "./slices/setting";
import notification from "./slices/notification";
import marketer from "./slices/marketers";
import lawyers from "./slices/lawyers";
import locations from "./slices/locations";
import category from "./slices/category";
import compliance from "./slices/compliance";
import admin from "./slices/admin-user";

export const store = configureStore({
  reducer: {
    opportunity,
    service,
    auth,
    loading,
    blog,
    request,
    companiesFile,
    training,
    country,
    companies,
    user,
    setting,
    notification,
    marketer,
    lawyers,
    locations,
    category,
    compliance,
    admin,
  },
  // devTools: process.env.NODE_ENV === "production" ? false : true,
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
